import React from 'react';
import { FormattedMessage } from 'react-intl';

import GIButton from '@components/common/button/GIButton';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { INPUT_TYPES } from '@components/common/form/constants/fieldTypes';
import Dropdown from '@lib/inputs/Dropdown';
import { ticketStatusOptions, watcherStatusOptions } from '../constants/ticketlist.constants';
import { IDefaultSearchProps } from '../constants/ticketlist.interface';
import {
    FlexContainer,
    FlexItem,
    FlexRow,
    StyledForm,
    StyledSearchControl,
    StyledSearchControlActions,
} from '../constants/ticketlist.styled';
import { handleChange } from '../constants/ticketlist.utils';
import { useDefaultSearch } from './useDefaultSearch';

export const DefaultSearch: React.FC<IDefaultSearchProps> = props => {
    const { workgroupOptions, isInitialLoad, isWatchTicketAllowed } = props;

    const {
        setValue,
        handleSubmit,
        watch,
        fetchFilteredTickets: onSubmit,
        tktAssignmentOptions,
        handleTicketAssignmentChange,
    } = useDefaultSearch({ isInitialLoad });

    const values = watch();

    return (
        <StyledForm onSubmit={handleSubmit(onSubmit)}>
            <FlexContainer>
                <FlexRow className="default-search-items">
                    <FlexItem>
                        <Dropdown
                            label={{
                                text: <FormattedMessage id="ticketList.label.workgroup" />,
                                labelClass: ['dropdown-label'],
                            }}
                            inputData={{
                                id: 'workgroup',
                                inputClass: ['dropdown-input'],
                                name: 'documentType',
                                type: INPUT_TYPES.DROPDOWN,
                                value: values.workgroup,
                                options: workgroupOptions,
                            }}
                            inputActions={{
                                handleFieldChange: e => handleChange('workgroup', e, setValue),
                            }}
                        />
                    </FlexItem>
                    <FlexItem>
                        <Dropdown
                            label={{
                                text: <FormattedMessage id="ticketList.label.ticketStatus" />,
                                labelClass: ['dropdown-label'],
                            }}
                            inputData={{
                                id: 'ticketStatus',
                                inputClass: ['dropdown-input'],
                                name: 'documentType',
                                options: ticketStatusOptions,
                                type: INPUT_TYPES.DROPDOWN,
                                value: values.ticketStatus,
                            }}
                            inputActions={{
                                handleFieldChange: handleTicketAssignmentChange,
                            }}
                            shouldParse
                        />
                    </FlexItem>
                    <FlexItem>
                        <Dropdown
                            label={{
                                text: <FormattedMessage id="ticketList.label.ticketAssignment" />,
                                labelClass: ['dropdown-label'],
                            }}
                            inputData={{
                                id: 'ticketAssignment',
                                inputClass: ['dropdown-input'],
                                name: 'documentType',
                                options: tktAssignmentOptions,
                                type: INPUT_TYPES.DROPDOWN,
                                value: values.ticketAssignment,
                            }}
                            inputActions={{
                                handleFieldChange: e => handleChange('ticketAssignment', e, setValue),
                            }}
                            shouldParse
                        />
                    </FlexItem>
                    <ConditionalRendering isTrue={isWatchTicketAllowed}>
                        <FlexItem>
                            <Dropdown
                                label={{
                                    text: <FormattedMessage id="ticketList.label.watcherStatus" />,
                                    labelClass: ['dropdown-label'],
                                }}
                                inputData={{
                                    id: 'watchStatusBasic',
                                    inputClass: ['dropdown-input'],
                                    name: 'documentType',
                                    options: watcherStatusOptions,
                                    type: INPUT_TYPES.DROPDOWN,
                                    value: values.watchStatusBasic,
                                }}
                                inputActions={{
                                    handleFieldChange: e => handleChange('watchStatusBasic', e, setValue),
                                }}
                                shouldParse
                            />
                        </FlexItem>
                    </ConditionalRendering>
                </FlexRow>
                <StyledSearchControl>
                    <StyledSearchControlActions>
                        <FlexItem>
                            <GIButton
                                id="defaultSearchButton"
                                labelId="ticketList.btn.searchMyTicket"
                                type="submit"
                                isDisabled={false}
                            />
                        </FlexItem>
                    </StyledSearchControlActions>
                </StyledSearchControl>
            </FlexContainer>
        </StyledForm>
    );
};
